import { BatchEditCampaignPage } from 'components/BatchEditCampaign/BatchEditCampaignPage';
import { ScheduleSummaryStateContentModel } from './ScheduleSummaryStateContentModel';
import i18n from 'i18n';
import { BatchEditCampaignSection } from 'components/BatchEditCampaign/BatchEditCampaignSection';
import { InfoDisplaySectionTitle } from 'components/InfoDisplaySection/InfoDisplaySection';
import { useCallback } from 'react';
import SummaryDetail from 'components/SummaryDetail/SummaryDetail';
import styles from './scheduleSummaryStateContent.module.scss';
import { StickableTanstackTable } from 'components/common/Table/StickableTanstackTable';

export const ScheduleSummaryStateContent: React.FC<{
  model: () => ScheduleSummaryStateContentModel;
}> = ({ model: useModel }) => {
  const { scheduleSummaryData, conflictTableData } = useModel();

  const renderSummaryDetails = useCallback(() => {
    if (!scheduleSummaryData) {
      return null;
    }
    return Object.keys(scheduleSummaryData).map((key) => {
      if (!scheduleSummaryData[key]) {
        return <div key={key} />;
      }
      const content = scheduleSummaryData[key].content;
      return (
        <SummaryDetail
          key={key}
          title={scheduleSummaryData[key].title}
          data={content}
          prefixColor={scheduleSummaryData[key].titlePrefixColor}
        />
      );
    });
  }, [scheduleSummaryData]);

  return (
    <BatchEditCampaignPage title={i18n.t('modifyScheduleState.title')}>
      <BatchEditCampaignSection
        title={i18n.t('batchEditCampaignSummary.labels.checkYourSettings')}
      >
        <div style={{ padding: '30px' }}>
          <InfoDisplaySectionTitle
            className={styles.scheduleSummaryTitle}
            title={i18n.t('campaignSummary.titles.basicSetting')}
          />
          {renderSummaryDetails()}
        </div>
        {conflictTableData && conflictTableData.data.length > 0 && (
          <div className={styles.conflictSummary}>
            <InfoDisplaySectionTitle
              title={i18n.t('modifyScheduleState.titles.conflictCampaigns')}
              hint={i18n.t('modifyScheduleState.hints.conflictCampaigns')}
              className={styles.conflictSummaryTitle}
            />
            <StickableTanstackTable
              keyField='id'
              data={conflictTableData.data}
              columns={conflictTableData.columns}
              hidePagination={true}
              className={styles.conflictSummaryTable}
            />
          </div>
        )}
      </BatchEditCampaignSection>
    </BatchEditCampaignPage>
  );
};
